import { useQuery } from '@tanstack/react-query'
import { IProjectDTO } from 'data/dtos/automation/i-project-dto'
import { PropsWithChildren, createContext, useContext, useState } from 'react'
import { loadItem } from 'services/requests'

interface IProjectContextData {
  isLoading: boolean
  isError: boolean
  data: IProjectDTO
  selectedTab: number
  tabOptions: string[]
  changeTab: (tab: number) => void
  refreshData: () => Promise<any>
  changeProjectId: (projectId: string) => void
}

const ProjectContext = createContext<IProjectContextData>({} as IProjectContextData)

const ProjectProvider = ({ children }: PropsWithChildren) => {
  const [id, setId] = useState<string | null>(null)
  const [selectedTab, setSelectedTab] = useState<number>(0)

  const tabOptions: string[] = [
    'Fluxo de trabalho',
    'Tabelas de entrada',
    'Tabelas de saída',
    'Conectores e Apps',
    // 'Histórico',
    // 'Processo',
  ]

  const handleChangeTab = (tab: number) => setSelectedTab(tab)

  const handleChangeProjectId = (projectId: string) => setId(projectId)

  const {
    data: reponse,
    isPending,
    isError,
    refetch,
  } = useQuery({
    queryKey: ['project', id],
    queryFn: () => loadItem('/projects', id ?? ''),
    enabled: id != null,
    refetchInterval: 10000,
    select: (data) => data.data.data,
  })

  let data: IProjectDTO = reponse || null

  return (
    <ProjectContext.Provider
      value={{
        data: data as IProjectDTO,
        isError,
        tabOptions,
        selectedTab,
        isLoading: isPending,
        refreshData: refetch,
        changeTab: handleChangeTab,
        changeProjectId: handleChangeProjectId,
      }}
    >
      {children}
    </ProjectContext.Provider>
  )
}

const useProject = (): IProjectContextData => useContext(ProjectContext)

export { ProjectProvider, useProject }
